import React from 'react';
import { PromoBar } from './components/PromoBar';
import { PromoModal } from './components/PromoModal';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TransformationBanner } from './components/TransformationBanner';
import { ProblemSection } from './components/ProblemSection';
import { ContractorTypes } from './components/ContractorTypes';
import { StorySection } from './components/StorySection';
import { WhatYouGet } from './components/WhatYouGet';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { VideoSpotlight } from './components/VideoSpotlight';
import { Process } from './components/Process';
import { Confidence } from './components/Confidence';
import { Reviews } from './components/Reviews';
import { ServiceArea } from './components/ServiceArea';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingEstimate } from './components/FloatingEstimate';
export function App() {
  return <div className="min-h-screen w-full bg-white font-sans" data-id="element-0" data-mp="3mkre1ma1tjdu">
      <PromoBar data-id="element-1" data-mp="3mj6k9yvk64h1" />
      <Header data-id="element-2" data-mp="3rcj7q5oi4587" />
      <main data-id="element-3" data-mp="3rbzmog3k10py">
        <Hero data-id="element-4" data-mp="3rdar8i4tqci4" />
        <TransformationBanner data-id="element-5" data-mp="3rcsyvwla8ifh" />
        <ProblemSection data-id="element-6" data-mp="3relw6la09qat" />
        <ContractorTypes data-id="element-7" data-mp="6hr7hlrojf6" />
        <StorySection data-id="element-8" data-mp="4n4pyuukj8z" />
        <WhatYouGet data-id="element-9" data-mp="56l3b4umzkw" />
        <Services data-id="element-10" data-mp="7sxpp6lk59z" />
        <Gallery data-id="element-11" data-mp="2zllf11m4wkmq" />
        <VideoSpotlight data-id="element-12" data-mp="2zm4y4lnitf2c" />
        <Process data-id="element-13" data-mp="2zmo5x9jgin2n" />
        <Confidence data-id="element-14" data-mp="2zn6cp03qwjot" />
        <Reviews data-id="element-15" data-mp="33mf2xuzktzfm" />
        <ServiceArea data-id="element-16" data-mp="33lwxq8uxsavk" />
        <Faq data-id="element-17" data-mp="33nggc642ey0i" />
        <FinalCta data-id="element-18" data-mp="33mym1f0yqtv8" />
      </main>
      <Footer data-id="element-19" data-mp="38lro8basuyg3" />
      <FloatingEstimate data-id="element-20" data-mp="38l8hzruihyhw" />
      <PromoModal data-id="element-21" data-mp="38kqau06b9zv7" />
    </div>;
}